<section class="cta-form">
    <div class="container-fluid" *ngIf="!loading">
        <form class="col-lg-12" [formGroup]="welcomePageForm">
            <section formGroupName="cta">

                <mat-form-field class="interval-container col-md-12" >
                    <mat-label>Swipe interval [Seconds]*</mat-label>
                    <input matInput type="number" formControlName="interval" />
                    <mat-error *ngIf="intervalControl.errors">Interval must be between 2 and 9</mat-error>
                </mat-form-field>

                <h3 class="cta-form-title">Welcome page</h3>
                <div formArrayName="slides">
                    <div class="slides-container" *ngFor="let i of slidesControl.controls; let idx = index" [formGroup]="slidesControl.controls[idx]">
                        <mat-checkbox
                            class="slide-checkbox"
                            formControlName="activated"
                            (change)="onSlideCheckboxChange($event, idx)"
                        >
                            Slide {{idx + 1}}
                        </mat-checkbox>
                        
                        <mat-form-field>
                            <mat-label >Module *</mat-label>
                            <mat-select class="col-md-12" formControlName="type">
                                <mat-option
                                    [value]="0"
                                >
                                    Not selected
                                </mat-option>
                                <mat-option
                                    *ngFor="let carouselType of carousel"
                                    [value]="carouselType"
                                    [disabled]="isCarouselOptionDisabled(carouselType)"
                                >
                                    {{ getCarouselSlideName(carouselType) }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
            </section>

            <div class="actions" *ngIf="displayActions">
                <div class="warning" *ngIf="welcomePageForm.dirty">You have unsaved changes.</div>
                <div>
                    <mat-spinner [diameter]="36" *ngIf="loading"></mat-spinner>
                </div>
                <button mat-raised-button [disabled]="loading || welcomePageForm.invalid" (click)="submit()" class="button">
                    Save
                </button>
            </div>
        </form>
    </div>
</section>